import { createEffect, sample } from 'effector';
import $$api from 'models/api';

// import { storage } from 'models/store-global';
import AlertsService from 'services/AlertsService';

sample({
    clock: [
        $$api.users.changePasswordFx.failData,
        $$api.users.checkEmailAvailableFx.failData,
        $$api.users.logoutUserFx.failData,
        $$api.users.searchParticipantsFx.failData,
        $$api.users.sendPasswordChangedEmailFx.failData,
        $$api.users.stopWorkingOnBehalfFx.failData,
        $$api.users.trackCurrentSectionFx.failData,
        $$api.users.setPasswordIsStrongFx.failData,
    ],
    target: createEffect(AlertsService.handleError),
});
